import {
  AdditionalConfiguration,
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionConfigurationControl,
  ReportSectionConfigurationControlType,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';

export class ItineraryActivityHistoryConfiguration extends ReportSectionConfigurationBase {
  typeName = 'ItineraryActivityHistoryConfiguration';
  nodataLocalizationKeyName = 'activityHistory';
  readonly reportSection = ReportSection.ItineraryActivityHistory;
  readonly applicableReportTypes = [ReportType.Itinerary];
  readonly reportViewModelSections = [ReportViewModelSection.Itinerary_ActivityHistory];
  override totalColumnsToDisplay = 3;

  minSize = 1;
  maxSize = 3;
  defaultSize = 2;
  name = 'activityHistory';
  displayName = 'Activity History';
  type = ReportSectionConfigurationControlType.Text;
  isSelected = true;
  canConfigure = true;
  property = 'activityHistory';
  readonly availableDataSections = [
    {
      name: 'itineratyActivityHistoryHeader',
      displayName: 'Date, Subject, Type',
      isSelected: true,
      canConfigure: false,
      isStatic: true
    },
    {
      name: 'activityHistoryExternalParticipants',
      displayName: 'External Participants',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'activityHistoryCompanyContacts',
      displayName: 'Company Contacts',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'itineratyActivityHistoryNotes',
      displayName: 'Activity Notes',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'itineraryCustomFields',
      displayName: 'Activity Custom Fields',
      isSelected: true,
      canConfigure: true
    }
  ];

  override additionalConfiguration: AdditionalConfiguration = {
    isTruncated: true,
    truncationLength: 7,
    listCountConfig: {
      min: 1,
      max: 5,
      default: 2,
      value: 2,
      listCountHeader: 'noOfLastInteractions'
    },
    toggleLabel: 'itineraryActivityHistoryTruncationToggle',
    activityHistoryExternalParticipantsOnly: false,
    showNotesAndCustomfieldsLatestActivityOnly: true
  };

  override configurationControls: ReportSectionConfigurationControl[] = [
    {
      name: 'activityHistoryRecordCount',
      displayName: 'Number of last interactions',
      type: 'rowCount'
    },
    {
      name: 'activityTruncation',
      displayName: 'Activity Truncation',
      applicableDataSection: 'activityHistory',
      type: 'truncation'
    }
  ];
}
